export default __webpack_public_path__ + "ed4f8d416a3a078c2340de945bb48e33.png";